import { useContext, useEffect, useState } from "react";
import AppUserContext from "../../../context/app-user-context";
import ChangeAlias from "../../../components/portal/ChangeAlias";
import NewLineToBreak from "../../../components/static/NewLineToBreak";

export default function PageProfile_Student() {
  const user = useContext(AppUserContext);

  return <>
    <div className="mgr__profile-details mgr__profile-details--wide">
      <div>
        <h1 className="mgr__profile-details__title d-none">My Profile</h1>
        <div className="mgr__profile-details__info">
          <p className="label">Name</p>
          <span className="separator">:</span>
          <p className="value">{user?.name ?? "-"}</p>

          <p className="label">Email</p>
          <span className="separator">:</span>
          <p className="value value--normal">{ user?.email ?? "-" }</p>

          <p className="label">Programme</p>
          <span className="separator">:</span>
          <p className="value">{ user?.programmeName ?? "-" }</p>

          <p className="label">Employer</p>
          <span className="separator">:</span>
          <p className="value">{ user?.organizationName }</p>

          <p className="label">Job Title</p>
          <span className="separator">:</span>
          <p className="value">{ user?.jobTitle ?? "-" }</p>

          <p className="label">Job Description</p>
          <span className="separator">:</span>
          <p className="value value--normal">
            <NewLineToBreak value={ user?.jobDescription ?? "-" } />
          </p>

          <p className="label d-flex align-items-center">Alias</p>
          <span className="separator d-flex align-items-center">:</span>
          <div className="value d-flex align-items-center">
            <ChangeAlias />
          </div>
        </div>
      </div>
    </div>
  </>;
}
